// ─── SHAREABLE ORDER DRAFT ────────────────────────────────────────────────────
// A buyer can share their cart with a manager as a self-contained link. The
// whole order is snapshotted into the URL (?draft=…) — no backend, no stored
// record — so the manager sees exactly what the buyer saw (quantities AND the
// prices at share time), even if catalogue prices later change. Product names
// AND images are resolved live from the catalogue by id on the viewing side, so
// neither is embedded here — this keeps the URL compact even for large,
// Arabic-named carts (Arabic tripled by percent-encoding is what blows a URL
// past client length limits). The viewer falls back to the SKU if a product is
// no longer in the catalogue.
//
// Encoded shape (short keys to keep the URL compact):
//   { v:1, t:type, n:note, l:[ { i:id, s:sku, q:qty, p:price|null } ] }

export function encodeOrderDraft({ type, note, lines }) {
  const payload = {
    v: 1,
    t: type || 'noprice',
    n: note || '',
    l: (lines || []).map(x => ({
      i: x.id, s: x.sku || '', q: x.qty, p: x.price == null ? null : x.price,
    })),
  };
  // encodeURIComponent → pure ASCII (percent-escaped UTF-8), so btoa stays safe
  // for the note (which may be Arabic). Then make the base64 URL-safe.
  const b64 = btoa(encodeURIComponent(JSON.stringify(payload)));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decodeOrderDraft(str) {
  if (!str) return null;
  try {
    let b64 = String(str).replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    const payload = JSON.parse(decodeURIComponent(atob(b64)));
    if (!payload || payload.v !== 1 || !Array.isArray(payload.l)) return null;
    return {
      type: payload.t || 'noprice',
      note: typeof payload.n === 'string' ? payload.n : '',
      lines: payload.l
        .map(x => ({
          id: x.i, sku: x.s || '', name_en: x.ne || '', name_ar: x.na || '',
          qty: Number(x.q) || 0, price: x.p == null ? null : Number(x.p),
        }))
        .filter(x => x.id && x.qty > 0),
    };
  } catch { return null; }
}
